var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasBills)?_c(_vm.print_type,{tag:"component",attrs:{"debit_statement":_vm.debit_statement}}):_vm._e(),(!_vm.hasBills)?_c('span',{staticClass:"ma-5 text-h5"},[_vm._v(" Nada Consta ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }